// 폼 타입 정의
export const FormType = {
  CREATE: 'CREATE',
  UPDATE: 'UPDATE',
  READONLY: 'READONLY',
} as const;

export type TFormType = (typeof FormType)[keyof typeof FormType];

// 폼 ID 정의
export const FORM_IDS = {
  MYINFO: 'myInfoForm',
  MENU: 'menuForm',
  EMPLOYEE: 'employeeForm',
  GROUP: 'groupForm',
  MAINVISUAL: 'mainvisualForm',
  BUSINESS: 'businessForm',
  CATEGORY: 'categoryForm',
  HISTORY: 'historyForm',
  PARTNER: 'partnerForm',
  EVENT: 'eventForm',
  MATERIALS: 'materialsForm',
  NEWS: 'newsForm',
  NOTICE: 'noticeForm',
  RECRUIT: 'recruitForm',
  RECRUIT_DOWNLOAD: 'recruit_download_Form',
  POPUP: 'popupForm',
} as const;
